var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("btn-wrapper " + (_vm.link.direction))},[_c('router-link',{class:("btn " + (_vm.link.color)),attrs:{"to":_vm.link.url}},[_vm._v(_vm._s(_vm.link.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }